"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const block_reference_1 = require("../node/expression/block-reference");
const constant_1 = require("../node/expression/constant");
const block_1 = require("../node/block");
const print_1 = require("../node/print");
/**
 * Filters a section of a template by applying filters.
 *
 * <pre>
 * {% filter upper %}
 *  This text becomes uppercase
 * {% endfilter %}
 * </pre>
 */
class TwingTokenParserFilter extends token_parser_1.TwingTokenParser {
    parse(token) {
        console.error('The "filter" tag is deprecated since Twig 2.9, use the "apply" tag instead.');
        let name = this.parser.getVarName();
        let ref = new block_reference_1.TwingNodeExpressionBlockReference(new constant_1.TwingNodeExpressionConstant(name, token.getLine(), token.getColumn()), null, token.getLine(), token.getColumn(), this.getTag());
        let filter = this.parser.getExpressionParser().parseFilterExpressionRaw(ref, this.getTag());
        this.parser.getStream().expect(token_1.TwingToken.BLOCK_END_TYPE);
        let body = this.parser.subparse([this, this.decideBlockEnd], true);
        this.parser.getStream().expect(token_1.TwingToken.BLOCK_END_TYPE);
        let block = new block_1.TwingNodeBlock(name, body, token.getLine(), token.getColumn());
        this.parser.setBlock(name, block);
        return new print_1.TwingNodePrint(filter, token.getLine(), token.getColumn(), this.getTag());
    }
    decideBlockEnd(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, 'endfilter');
    }
    getTag() {
        return 'filter';
    }
}
exports.TwingTokenParserFilter = TwingTokenParserFilter;
